<section>
    <h1 class="mat-display-1">Terms and Conditions: Campaigns</h1>
</section>
<div class="content">
    <mat-accordion>
        <div class="terms-list">

            <mat-expansion-panel [expanded]="fragment() == 'xmashunt2025'">
                <mat-expansion-panel-header>
                    <h3 id="xmashunt2025">cloudigo Bruno’s Christmas Treasure Hunt December 2025 Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        Between <strong>1 December 2025</strong> and <strong>25 December 2025</strong>, registered users of the <strong>cloudigo</strong> mobile application will have the opportunity to participate in <strong>Bruno’s Christmas Treasure Hunt</strong> (the “Game”). Each day, users may open a daily box to reveal a clue, which will assist them in locating Bruno’s missing item for that particular day. By finding the correct item, users may enter for a chance to win various discount codes and gift vouchers (collectively, the “Prize/s”) offered by <strong>Cloudigo Ltd (C89187)</strong> and/or its co-sponsoring partners.
                    </p>
                    <p>
                        This year’s Game includes <strong>three (3) Grand Prizes</strong>, consisting of:
                    </p>
                    <ul>
                        <li>One (1) Wine Bath experience for two (2) people at Dee Spas with a value of around €400</li>
                        <li>One (1) Laptop provided by Laptop Factory worth €399 (<a href="https://www.laptopfactorymalta.com/shop/asus-x515-celeron-laptop-n4500-malta-17153">link</a>)</li>
                        <li>One (1) €200 voucher from Nursery Direct</li>
                    </ul>

                    <p>
                        In addition, participants may be eligible to win <strong>Instant Prizes</strong>, which include discount codes to purchase <strong>cloudigo Premium</strong> at a reduced rate, as well as multiple €10 and €20 vouchers provided by partners featured on cloudigo. The respective Instant Prizes to be won are shown in the table below.
                    </p>
                    <ol class="sublisted">
                        <li>The Game is open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>The game is valid every day (‘Entry’) from 01/12/2025 till 25/12/2025 (‘Duration’). The final closing date for competition is 25/12/2025 at 11:59pm.</li>

                        <li>Participation in the game constitutes participant’s full acceptance of these Rules and Terms & Conditions. </li>

                        <li>To participate in this game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account Participant will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>.</li>

                        <li>The Game is available on the cloudigo application only. </li>

                        <li>Every Entry, Participants will be able to: 
                            <ol>
                                <li>Open the daily <strong>box</strong> for that specific date to reveal a <strong>clue</strong>.</li>
                                <li>Use the clue to browse the app and <strong>locate</strong> the <strong>missing item</strong> hidden within cloudigo.</li>
                                <li>Virtually scratch the screen once the item is found to see if they have won one of the Instant Prizes available in the Game.</li>
                                <li>If Participants miss any previous day's box, they will not be able to open it at a later stage during the duration of the Game.</li>
                                <li>After discovering whether an Instant Prize has been won, the Participants will automatically earn <strong>one point (“Ticket”)</strong>, which grants them an entry into the <strong>draw</strong> for the <strong>Grand Prizes</strong>.</li>
                            </ol>
                        </li>

                        <li>cloudigo reserves the right to modify and/or revoke the number of Tickets of each Participant if the need arises.</li>

                        <li>The Instant Prize/s won by the Winner/s will be displayed on the cloudigo application itself and the Winner/s will be instructed on how to obtain the Instant Prize. The Winner/s will be contacted via email, mobile phone (call or SMS)  and/or push notification according to the registered details of the Winner’s account.
                            <ol>
                                <li>Each Instant Prize has its own expiry date for redemption and is subject to the Gift Vouchers section of the General cloudigo Terms and Conditions found <a routerLink="/info/terms-and-conditions">here</a></li>
                                <li>If the Winner finds a cloudigo discount code as an Instant Prize, this will be displayed on the application for you to add to your account. Each cloudigo discount code has its own Terms and Conditions specified on the application and in line with the General Terms of Service and Privacy Policy found on the cloudigo website.</li>
                                <li>Alternatively, if the Winner finds an Instant Prize from one of our partnering brands, the Winner will either be able to redeem the Instant Prize at the specified brand location or instructed to collect the Instant Prize from our offices in Birkirkara, Malta. The Winner is instructed to look at the redeemable location of each Instant Prize in order to determine where to redeem it. In the event that the Instant Prize needs to be collected from the cloudigo offices, Winners must not collect their Prize later than 60 days after it has been assigned. For the avoidance of doubt, if the Winner does not collect the Instant Prize within the stipulated timeframe, the Winner will no longer be eligible to receive the Instant Prize.</li>
                                <li>The Prize terms and conditions in the Game shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>
                                <li>Winning a Prize is contingent upon the Participant fulfilling all requirements set forth in these Rules and Terms and Conditions.</li>
                                <li>Prizes won cannot be redeemed for cash and are not valid in conjunction with any other offer.</li>
                            </ol>
                        </li>

                        <li>The Grand Prize winners will be selected at random using a digital randomisation tool on <strong>6 January 2026</strong>. A total of <strong>nine (9)</strong> potential winners will be drawn, and the first three (3) drawn will be assigned prizes in the following order:
                            <ol>
                                <li><strong>First drawn participant</strong> – Wine Bath experience for two (2) from Dee Spas</li>
                                <li><strong>Second drawn participant</strong> – Laptop from Laptop Factory</li>
                                <li><strong>Third drawn participant</strong> – €200 Nursery Direct voucher</li>                               
                            </ol>
                            <ol type="a" class="sublisted">
                                <li>The first drawn potential winner (for each respective prize) will be contacted via the phone number and/or email address associated with their cloudigo account and will be granted forty-eight (48) hours to confirm acceptance of the prize.</li>
                                <li>If the potential winner does not respond within the specified timeframe, the prize will be offered to the next drawn potential winner. This process will continue until all Grand Prizes have been successfully awarded.</li>
                                <li>All Grand Prizes must be collected from the cloudigo office by no later than 31 January 2026. Winners may be required to present a valid identification document (ID Card or Passport) for verification purposes. By accepting the Prize, the Winner agrees to have their photo taken with the Prize, which may be used by cloudigo for marketing, promotional and/or public relations purposes.</li>
                                <li>Failure to collect the Prize within the timeframe stated and/or failure to provide valid identification may result in forfeiture of the Prize, with no alternative compensation offered.</li>
                            </ol>
                        </li>

                        <!-- <li>In total there are <span class="font-bold">one hundred and twenty-five (125) Prizes</span> to be won as shown below:
                            <ol>
                                <li>Ten (10) cloudigo discount codes by Cloudigo Ltd entitling the user to a free twelve (12) months on the cloudigo Premium Yearly Plan each valued at forty-nine euros and ninety-nine cents (€49.99)</li>
                                <li>Thirty (30) cloudigo discount codes by Cloudigo Ltd entitling the user to a fifty percent (50%) OFF on the cloudigo Premium Yearly Plan. The discount is equivalent to twenty-four euros and ninety-nine cents (€24.99)</li>
                                <li>Thirty (30) ten-euro (€10) each from one of the following brands: </li>
                                <ul>
                                    <li>Bites</li>
                                    <li>Borge</li>
                                    <li>Darmanin Footwear</li>
                                    <li>Eurosport</li>
                                    <li>Food Island</li>
                                    <li>Frullado</li>
                                    <li>Gallarija Darmanin</li>
                                    <li>JB Stores</li>
                                    <li>Jules</li>
                                </ul>
                                <li>Twenty-five (25) twenty-euro (€20) vouchers from one of the following brands: </li>
                                <ul>
                                    <li>AYU</li>
                                    <li>Coccinelle</li>
                                    <li>Cortefiel</li>
                                    <li>FINA</li>
                                    <li>Heirloom Streatery</li>
                                    <li>Springfield</li>
                                    <li>Toytastic</li>
                                    <li>Women'secret</li>
                                </ul>
                                <li>Thirty (30) free food vouchers from one of the following brands: </li>
                                <ul>
                                    <li>Billy Boyz</li>
                                    <li>NomNom</li>
                                    <li>Pastaus</li>
                                    <li>Pastaus Lab</li>
                                    <li>SC Food Corner</li>
                                    <li>Zmerc</li>
                                </ul>
                                
                            </ol>
                        </li> -->

                        <li>The names and/or photos of the Winners, may be announced and/or posted on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a>, the cloudigo application and/or website www.cloudigo.app.</li>
                        
                        <li>The Prize terms and conditions shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>
                        
                        <li>cloudigo ltd reserves the right to substitute the Prize for one of equal value in the event of circumstances beyond its control.</li>

                        <li>cloudigo Ltd reserves the right to remove, change or add any of the Prizes in the Game.</li>

                        <li>cloudigo Ltd reserves the right to shorten, extend, suspend and/or modify the Duration of the Game at its discretion and at any time.</li>

                        <li>cloudigo Ltd reserves the right to terminate or temporarily suspend the Game at any time, for any reason, with or without notice.</li>

                        <li>cloudigo Ltd reserves the right to disqualify any Participant or revoke any Prize if any abuse is detected.</li>

                        <li>cloudigo are in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>

                        <li>The game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.</li>

                        <li>The Game shall be subject to our general Terms and Conditions found on our <a href="https://www.cloudigo.app/info/terms-and-conditions">website</a>.</li>

                        <li>The Game shall be governed by, and construed in accordance with, the laws of Malta and the Courts of Malta shall have exclusive jurisdiction to determine any dispute in relation hereto.</li>

                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel class="bypass-visible" [expanded]="fragment() == 'swf-feb23'">
                <mat-expansion-panel-header>
                    <h3 id="swf-feb23">cloudigo Campaign - Save with a Friend and you’ll both get Premium at €29.99</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        These terms and conditions apply to cloudigo’s promotion named <span class="font-bold">‘Save with a Friend and you’ll both get Premium at €29.99’ (‘Discount’) (‘Promotion’)</span>, redeemable by inviting a friend to the cloudigo Premium Yearly Plan between 18th January 2023 and 31st December 2025 (“Promotion Period”).
                        <br/><br/>
                        For the Discount to be awarded successfully, specific events need to be performed by two parties. On one side, there will be the person inviting a friend (‘Sender’) and the person receiving the invitation to join Premium (‘Receiver’).
                        <br/><br/>
                        The following conditions apply to the Sender and Receiver of the Promotion:
                    </p>
                    <ol >
                        <li>By using this Promotion you agree to these terms and conditions. If you do not agree to these terms and conditions please do not use the Promotion. We reserve the right to refuse the Promotion to any person that does not satisfy these conditions of use.</li>
                        <li>During the Promotion period, you will be allocated a unique link/code which you will be able to send in order to invite others to the cloudigo Premium Yearly plan. </li>
                        <li>Invitations can be sent to the Receiver during the Promotion Period by sharing the unique link found on the profile section of your cloudigo account. This unique link can be shared directly or via a number of social media channels.</li>
                        <li>
                            Once the Receiver receives the unique link sent by the Sender, the Receiver will need to:
                            <ol>
                                <li>Click on the link shared with them. Once opened, the Receiver will get a unique code (‘Discount Code’) which will automatically be saved to his/her cloudigo account, if the Receiver is already logged in the cloudigo application or website. If the Receiver is not logged in, upon login/sign-up, the Receiver will still be allocated the respective Discount Code. </li>
                                <li>Subscribe to the cloudigo Premium Yearly Plan by entering credit card details and <span class="font-bold">applying the Discount Code received by the Sender</span> during the checkout process in the relevant section and paying the respective fee. After subscribing to cloudigo Premium yearly, the subscription will be automatically renewed for further periods of twelve (12) months each and the cloudigo Premium Yearly Plan fee for such renewal shall be debited to the card linked to your account, unless you cancel your subscription in accordance with our Terms and Conditions. Any renewals made after the application of the Discount Code upon subscription shall be charged at the then applicable annual fees available at the following link <a routerLink="/premium/yearly">www.cloudigo.app/premium/yearly</a>, unless any other discount code is applied during payment.</li>
                            </ol>
                        </li>
                        <li>Once the Receiver successfully subscribes to the Premium Yearly plan using the Discount Code provided by the Sender, the Sender will be informed via email and/or push notification and will also be rewarded a Discount Code . This Discount Code will also be automatically added to the account of the Sender. The Terms and Conditions related to the Discount Code are stipulated on code itself visible on the cloudigo application before redemption.</li>
                        <li>The Discount Code cannot be used for any other purpose, other than as set out in these terms and conditions. The Discount Code is personal to the user and the user cannot transfer or exchange the Discount Code for any amount, gift, items, money, vouchers or other form of compensation.</li>
                        <li>The user shall be solely responsible for claiming and redeeming the Discount Code when subscribing to the cloudigo Premium Yearly Plan. cloudigo shall not be held responsible for the Receiver’s failure to apply the Discount Code upon subscription or should the user become aware of the Promotion after having purchased any cloudigo Premium Yearly subscription plan.</li>
                        <li>For the Sender to benefit from the Promotion, the Receivers must have performed all the criteria specified within these Terms and Conditions. For the Sender to use the Discount code and purchase Premium Yearly at a discounted price, he/she needs to successfully refer one (1) person within the Promotion Period. This means that the Receiver needs to fully satisfy all the steps mentioned within these Terms and Conditions and subscribe to cloudigo Premium Yearly. </li>
                        <li>In order to qualify as a Sender of this Promotion, you need to be a cloudigo Free plan.</li>
                        <li>In order to qualify as a Receiver of this Promotion, you need to be a cloudigo Free plan</li>
                        <li>If you have previously subscribed to Premium through the ‘Save with a Friend and you’ll both get Premium at €29.99’’ campaign, you are not eligible to subscribe again via this same campaign.</li>
                        <li>As set out in our Privacy Policy and Terms and Conditions, you must be aged 16 or over in order to use cloudigo and redeem the Promotion.</li>
                        <li>Participation in this Promotion constitutes full acceptance of our General Terms & Conditions and Privacy Policy.</li>
                        <li>We reserve the right to modify, cancel or amend the Promotion at any time for whatever reason.</li>
                        <li>To the fullest extent permitted by law we exclude any and all liability for any loss, damage or injury occurring to you or any third party arising from this Promotion.</li>
                        <li>These terms are governed by the laws of Malta.</li>
                        <li>This Promotion is administered by Cloudigo Limited (Company Registration Number 89187) of 90, Office 1, Level 1, Psaila Street, Birkirkara, BKR 9073, Malta.</li>
                        <li>Further information and terms can be found at the following link; <a routerLink="/terms-and-conditions">cloudigo.app/info/terms-and-conditions</a></li>


                    </ol>
                </ng-template>
            </mat-expansion-panel>
            
            <mat-expansion-panel class="bypass-visible" [expanded]="fragment() == 'baf-may22'">
                <mat-expansion-panel-header>
                    <h3 id="baf-may22">cloudigo Campaign - Bring a Friend on Premium and get a €10 gift voucher</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        These terms and conditions apply to cloudigo’s promotion named <span class="font-bold">‘Bring a Friend on Premium and get a €10 Gift Voucher’ (‘Gift Voucher’) (‘Promotion’)</span>, redeemable by inviting a friend to the cloudigo Premium Yearly Plan from 30th August 2023 and 31st December 2025 (“Promotion Period”).
                        <br/><br/>
                        For the Gift Voucher to be awarded successfully, specific events need to be performed by two parties. On one side, there will be the person inviting a friend (‘Sender’) and the person receiving the invitation to join Premium (‘Receiver’).
                        <br/><br/>
                        The following conditions apply to the Sender and Receiver of the Promotion:
                    </p>
                    <ol >
                        <li>By using this Promotion you agree to these terms and conditions. If you do not agree to these terms and conditions please do not use the Promotion. We reserve the right to refuse the Promotion to any person that does not satisfy these conditions of use.</li>
                        <li>During the Promotion period, you will be allocated a unique link/code which you will be able to send in order to invite others to the cloudigo Premium Yearly plan. </li>
                        <li>Invitations can be sent to the Receiver during the Promotion Period by sharing the unique link found on the profile section of your cloudigo account. This unique link can be shared directly or via a number of social media channels.</li>
                        <li>
                            Once the Receiver receives the unique link sent by the Sender, the Receiver will need to:
                            <ol>
                                <li>Click on the link shared with them. Once opened, the Receiver will get a unique code (‘Discount Code’) which will automatically be saved to his/her cloudigo account, if the Receiver is already logged in the cloudigo application or website. If the Receiver is not logged in, upon login/sign-up, the Receiver will still be allocated the respective Discount Code. </li>
                                <li>Subscribe to the cloudigo Premium Yearly Plan by entering credit card details and <span class="font-bold">applying the Discount Code received by the Sender</span> during the checkout process in the relevant section and paying the respective fee. After subscribing to cloudigo Premium yearly, the subscription will be automatically renewed for further periods of twelve (12) months each and the cloudigo Premium Yearly Plan fee for such renewal shall be debited to the card linked to your account, unless you cancel your subscription in accordance with our Terms and Conditions. Any renewals made after the application of the Discount Code upon subscription shall be charged at the then applicable annual fees available at the following link <a routerLink="/premium/yearly">www.cloudigo.app/premium/yearly</a>, unless any other discount code is applied during payment.</li>
                            </ol>
                        </li>
                        <li>Each Discount Code may be used once, is redeemable exclusively during the Promotion Period and is subject to the Discount Codes section within the General Terms and Conditions of cloudigo found here: <a routerLink="/terms-and-conditions">cloudigo.app/info/terms-and-conditions</a></li>
                        <li>The Receiver cannot use the Discount Code for any other purpose, other than as set out in these terms and conditions. The Discount Code is personal to the Receiver and the Receiver cannot transfer or exchange the Discount Code for any amount, gift, items, money, vouchers or other form of compensation.</li>
                        <li>The Receiver shall be solely responsible for claiming and redeeming the Discount Code when subscribing to the cloudigo Premium Yearly Plan. cloudigo shall not be held responsible for the Receiver’s failure to apply the Discount Code upon subscription or should the Receiver become aware of the Promotion after having purchased any cloudigo Premium Yearly subscription plan.</li>
                        <li>Once the Receiver successfully subscribes to the Premium Yearly plan using the Discount Code provided by the Sender, the Sender will be informed via email and/or push notification and will be rewarded a €10 Gift Voucher from Matalan to his/her account. The Terms and Conditions related to the €10 Gift Voucher from Matalan are stipulated on the Gift Voucher itself visible on the cloudigo application before redemption</li>
                        <li>For the Sender to benefit from the Promotion, the Receivers must have performed all the criteria specified within these Terms and Conditions.  For the Sender to redeem the Gift Voucher, he/she needs to successfully refer one (1) person within the Promotion Period. This means that the Receiver needs to fully satisfy all the steps mentioned within these Terms and Conditions and subscribe to cloudigo Premium Yearly. </li>
                        <li>In order to qualify as a Sender of this Promotion, you need to be a cloudigo Premium Yearly plan user or a cloudigo Corporate plan user .</li>
                        <li>In order to qualify as a Receiver of this Promotion, you need to be a cloudigo Free plan and/or Monthly user.</li>
                        <li>As set out in our Privacy Policy and Terms and Conditions, you must be aged 16 or over in order to use cloudigo and redeem the Promotion.</li>
                        <li>If you have previously subscribed to Premium through the ‘Bring a Friend on Premium and get a €10 gift voucher’ campaign, you are not eligible to subscribe again via this same campaign.</li>
                        <li>Participation in this Promotion constitutes full acceptance of our General Terms & Conditions and Privacy Policy.</li>
                        <li>We reserve the right to modify, cancel or amend the Promotion at any time for whatever reason.</li>
                        <li>To the fullest extent permitted by law we exclude any and all liability for any loss, damage or injury occurring to you or any third party arising from this Promotion.</li>
                        <li>These terms are governed by the laws of Malta.</li>
                        <li>cloudigo is in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>
                        <li>The campaign is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this campaign.</li>
                        <li>This Promotion is administered by Cloudigo Limited (Company Registration Number 89187) of 90, Office 1, Level 1, Psaila Street, Birkirkara, BKR 9073, Malta.</li>
                        <li>Further information and terms can be found at the following link; <a routerLink="/terms-and-conditions">cloudigo.app/info/terms-and-conditions</a></li>
                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel class="bypass-visible" [expanded]="fragment() == 'generic-quiz'">
                <mat-expansion-panel-header>
                    <h3 id="generic-quiz">cloudigo Campaign - Weekly Quiz Rules and Terms & Conditions on the cloudigo App</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the ‘<span color="primary">cloudigo Quiz</span>’ (‘Game’) on the cloudigo application, everyday you (‘Participant’) will have a chance to answer a number of questions in our quiz Game within the given duration of the Game and will enter the chance of winning one of the gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>
                    <ol >
                        <li>The Game is open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>The end date of each Game will be displayed on the Game itself on the cloudigo application.</li>

                        <li>Participation in the game constitutes participant’s full acceptance of these Rules and Terms & Conditions.</li>

                        <li>To participate in this Game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account, participants will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>. Participants will also be required to create a username of their choice which will then be displayed in the leader board of the Game on the cloudigo application. We reserve the right to disqualify any Participants with inappropriate usernames.</li>

                        <li>Participants have one chance to play the Game. This means that Participants can participate once within the Duration of the Game entering the chance of winning one of the Prizes specified in the Game. </li>

                        <li>Winning a prize is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions. If, when participating in any cloudigo quiz on the cloudigo app or website, you win a minimum of three (3) Prizes (irrespective of value) within the one hundred and eighty (180) days prior to the next draw date of this cloudigo quiz, you will not be eligible to participate in this cloudigo quiz. </li>

                        <li>In order for Participants get the chance to win a Prize (‘Winners’), the following rules apply. 
                            <ol>
                                <li>Participants will be able to answer a number of questions.</li>
                                <li>A maximum number of points can be accumulated for each question.</li>
                                <li>Points are only awarded if at least one (1) question is answered correctly.</li>
                                <li>Participants will have a maximum amount of time to answer each question.</li>
                                <li>After Participants will finish answering the required number of questions, the system will award the total amount of points to the Participants based on (a) how many questions were answered correctly and (b) the speed of answering each question. As time passes, points are deducted at a fixed rate.</li>
                                <li>Up to Twenty-four (24) hours after the end of the Duration of the Game, the best score of the top Participants marked by the sign of a crown indicated on the leaderboard, who participated in the Game according to the leaderboard of the cloudigo Game and will be the Winners of the Game.</li>
                                <li>Participants will also be informed that they are Winners via email and/or push notifications. You should ensure that your registration details are correct and up to date as otherwise we may not be able to reach you.</li>
                                <li>In order to qualify as a Winner, Participants must have gained at least one (1) point.</li>
                            </ol>
                        </li>

                        <li>The total number of Prizes to be won will be displayed on the Quiz Game itself on the cloudigo application. These will be awarded to the Winners of the Game. Prizes will be automatically accessible and redeemable on the My Gifts section of the cloudigo application.
                            <ol>
                                <li>Winners will not be able to choose the gift voucher they would like to win. These gift vouchers will be selected at random and awarded to the Winners accordingly. </li>
                                <li>In the event that the Prize needs to be collected from our offices in Birkirkara, then the Prize must be collected by the actual Winner of the Game together with a valid identification card. The Winner needs to present the Gift on his/her account on the cloudigo application at the cloudigo offices for the cloudigo Team to scan and validate the Gift. For the avoidance of doubt, if the Winner does not collect the Prize within the stipulated date, the Winner will no longer be eligible to receive the Prize.</li>
                            </ol>
                        </li>
                        <li>Prizes won cannot be redeemed for cash and are not valid in conjunction with any other offer.</li>

                        <li>After the Duration of the Game, the usernames, names and/or usernames of the Winners may be announced on the ‘cloudigo’ Social Media channels such as <a href="https://www.facebook.com/cloudigo" target="_blank">Facebook</a>, <a href="https://www.instagram.com/cloudigomt/" target="_blank">Instagram</a>, <a href="https://linkedin.com/company/cloudigomt" target="_blank">LinkedIn</a> etc and/or the cloudigo application or website <a routerLink="/">www.cloudigo.app</a>.</li>

                        <li>The Winner/s may be asked for his/her consent to take an official photo with the Prize/s. This may then be posted on the cloudigo Social Media Channels and/or cloudigo app/website subject to said prior consent.</li>
                        
                        <li>The Prize terms and conditions shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>

                        <li>cloudigo ltd reserves the right to substitute the Prize for one of equal value in the event of circumstances beyond its control.</li>

                        <li>cloudigo is in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>

                        <li>The game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.</li>

                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel class="bypass-visible" [expanded]="fragment() == 'competitions'">
                <mat-expansion-panel-header>
                    <h3 id="competitions">Terms and Conditions related to any cloudigo Competition (‘Competition’) on the cloudigo Social Media Channel/s, application and/or website</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <h4>
                        <ol>
                            <!-- 1 -->
                            <li>The owner and promoter of such Competition is Cloudigo Ltd (‘cloudigo’) unless otherwise specified.</li>
                            <!-- 2 -->
                            <li>The Competition is open to anyone who has downloaded the cloudigo application and/or registered to <a routerLink="/">www.cloudigo.app</a> and is aged 18 or over (‘Participant’), excluding employees of cloudigo, their agents or families or anyone else connected with the Competition.</li> 
                            <!-- 3 -->
                            <li>The Competition is valid during the period (‘Competition Validity Period’) specified in the details of the Competition on the cloudigo Social Media Channels, application and/or website.</li>
                            <!-- 4 -->
                            <li>Participation in the Competition constitutes the Participant's full acceptance of these Rules and our Terms & Conditions.</li> 
                            <!-- 5 -->
                            <li>To participate in the Competition, the Participant needs to follow the instructions indicated on the competition itself.</li>
                            <!-- 6 -->
                            <li>Cloudigo Social Media channels may include but are not limited to the cloudigo Facebook page, Instagram Page, Linkedin page, or any other Social Media channel cloudigo may be using.</li>
                            <!-- 7 -->
                            <li>Up to two (2) working days after the end of the Competition Validity period, participant/s of the Competition will be chosen at random in accordance with the instructions indicated on the Competition will be declared the winner/s (‘Winner/s’) of the Competition and will be entitled to a Prize (‘Prize/s’).</li>
                            <!-- 8 -->
                            <li>The details of the Prize/s are specified in the details of the Competition.</li>
                            <!-- 9 -->
                            <li>If the Winner is entitled to a Prize/s such as a gift voucher from one of our partnering brands, the Winner will either be able to redeem the Prize/s at the specified brand location or instructed to collect the Prize/s from our offices in Birkirkara, Malta. 
                                <ol>
                                    <li>If the Prize needs to be collected from our offices in Birkirkara, the Prize must be collected by the actual Winner of the Game. The Winner needs to present the Gift on his/her account on the cloudigo application at the cloudigo offices for the cloudigo Team to scan and validate the Gift. This must be collected no later than one (1) month of notification as to his/her being the Winner/s.</li>
                                    <li>Cloudigo reserves the right to ask the Winner/s to show his/her identification card.</li>
                                    <li>Where the Prize/s needs to be collected from our offices by the Winner, the arrangements,where applicable, will be conducted via the cloudigo Social Media Channel or email/phone, where applicable, after contact.</li>
                                    <li>The Winner/s must have downloaded the cloudigo application and/or registered to <a routerLink="/">www.cloudigo.app</a>.</li>
                                </ol>
                            </li>
                            <!-- 10 -->
                            <li>If the Competition is running on a cloudigo Social Media Channel, the Winner/s shall be contacted through a personal message from the cloudigo Social Media Channel or via email address/mobile number where applicable. If the Winner/s does not answer the personal message within twenty-four (24) hours of contact, the Prize/s shall be awarded to the next winner in line.</li>
                            <!-- 11 -->
                            <li>The Winner/s may be asked a cloudigo related question. Should the Winner/s fail to give the correct answer to this cloudigo related question, the Winner/s may lose the Prize/s should this have been indicated as a condition for eligibility in the details of the Competition.</li>
                            <!-- 12 -->
                            <li>Prize/s cannot be exchanged or redeemed for cash.</li>
                            <!-- 13 -->
                            <li>The Prize/s shall be subject to terms and conditions for use applied by the brand sponsoring the prize. Any complaints regarding the Prize/s must be addressed directly to the brand that is sponsoring the Prize/s.</li>
                            <!-- 14 -->
                            <li>cloudigo reserves the right to substitute the Prize/s for one of equal value in the event of circumstances beyond its control.</li>
                            <!-- 15 -->
                            <li>The Winner/s may be officially announced on the cloudigo Social Media Channels and/or cloudigo app/website. The Winner/s may be asked for his/her consent to take an official photo with the Prize/s. This may then be posted on the cloudigo Social Media Channels and/or cloudigo app/website subject to said prior consent.</li>
                            <!-- 16 -->
                            <li>For the Participant to participate in the Competition, cloudigo needs to process the Participant’s personal data. Any such processing of personal data is done in accordance with cloudigo’s Privacy Policy.</li>
                            <!-- 17 -->
                            <li>cloudigo reserves the right to terminate or suspend participation of participant/s in the event of any abuse or misuse of this Competition.</li>
                            <!-- 18 -->
                            <li>cloudigo reserves the right to suspend, modify or terminate a Competition at any time by giving immediate notice via the cloudigo Facebook/Instagram Page/s and/or the cloudigo website (<a routerLink="/">www.cloudigo.app</a>)</li>       
                        </ol>
                        <br/><br/>
                        Link to cloudigo website: <a routerLink="/">https://cloudigo.app</a>.
                        <br/>
                        Link to cloudigo Facebook Page: <a href="https://www.facebook.com/cloudigo" target="_blank">https://www.facebook.com/cloudigo</a>.
                        <br/>
                        Link to cloudigo Instagram Page: <a href="https://www.instagram.com/cloudigomt/" target="_blank">https://www.instagram.com/cloudigomt/</a>.
                        <br/>
                        Link to cloudigo Linkedin Page: <a href="https://www.linkedin.com/company/cloudigomt" target="_blank">https://www.linkedin.com/company/cloudigomt</a>.
                    </h4>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="fragment() == 'springquest25'">
                <mat-expansion-panel-header>
                    <h3 id="springquest25">cloudigo’s Spring Quest Treasure Hunt May 2025 Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the ‘<span color="primary">cloudigo’s Spring Quest Treasure Hunt May 2025</span>’ (‘Game’) on the cloudigo application, you (‘Participant’) will be able to open a box linked to that particular day in order to reveal a clue. The clue will aid you in finding the missing sticker of that particular day and enter the chance of winning one of the many discount codes and gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>
                    <ol >
                        <li>The Game is open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>The game is valid every day (‘Entry’) from 19/05/2025 till 01/06/2025 (‘Duration’). The final closing date for competition is 01/06/2025 at 11.59pm.</li>

                        <li>Participation in the game constitutes participant’s full acceptance of these Rules and Terms & Conditions. </li>

                        <li>To participate in this game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account Participant will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>.</li>

                        <li>The Game is available on the cloudigo application only. </li>

                        <li>Every Entry, Participants will be able to: 
                            <ol>
                                <li>Open the box of that particular day in order to reveal a clue.</li>
                                <li>Once the clue is revealed, the Participant needs to browse the app and locate the missing sticker.</li>
                                <li>When the Participant finds the missing sticker, they are required to virtually scratch the screen to enter the chance of winning one of the Prizes specified in the Game. If the Participant fails to open one of the previous boxes prior to that day, the Participant will have the opportunity to open them anyway. Winning a prize is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions.</li>
                            </ol>
                        </li>

                        <li>In total there are <span class="font-bold">one hundred and twenty-five (125) Prizes</span> to be won as shown below:
                            <ol>
                                <li>Ten (10) cloudigo discount codes by Cloudigo Ltd entitling the user to a free twelve (12) months on the cloudigo Premium Yearly Plan each valued at forty-nine euros and ninety-nine cents (€49.99)</li>
                                <li>Thirty (30) cloudigo discount codes by Cloudigo Ltd entitling the user to a fifty percent (50%) OFF on the cloudigo Premium Yearly Plan. The discount is equivalent to twenty-four euros and ninety-nine cents (€24.99)</li>
                                <li>Thirty (30) ten-euro (€10) each from one of the following brands: </li>
                                <ul>
                                    <li>Bites</li>
                                    <li>Borge</li>
                                    <li>Darmanin Footwear</li>
                                    <li>Eurosport</li>
                                    <li>Food Island</li>
                                    <li>Frullado</li>
                                    <li>Gallarija Darmanin</li>
                                    <li>JB Stores</li>
                                    <li>Jules</li>
                                </ul>
                                <li>Twenty-five (25) twenty-euro (€20) vouchers from one of the following brands: </li>
                                <ul>
                                    <li>AYU</li>
                                    <li>Coccinelle</li>
                                    <li>Cortefiel</li>
                                    <li>FINA</li>
                                    <li>Heirloom Streatery</li>
                                    <li>Springfield</li>
                                    <li>Toytastic</li>
                                    <li>Women'secret</li>
                                </ul>
                                <li>Thirty (30) free food vouchers from one of the following brands: </li>
                                <ul>
                                    <li>Billy Boyz</li>
                                    <li>NomNom</li>
                                    <li>Pastaus</li>
                                    <li>Pastaus Lab</li>
                                    <li>SC Food Corner</li>
                                    <li>Zmerc</li>
                                </ul>
                                
                            </ol>
                        </li>
                        <li>If a Participant finds a Prize whilst playing this Game, then he or she becomes a winner (‘Winner’). The Prize won by the Winner will be displayed on the cloudigo application itself and the Winner will be instructed on how to obtain the Prize.
                            <ol>
                                <li>If the Winner finds a cloudigo discount code, this will be displayed on the application for you to add to your account. Each cloudigo discount code has its own Terms and Conditions specified on the application and in line with the General Terms of Service and Privacy Policy found on the cloudigo website.</li>
                                <li>Alternatively, if the Winner finds a gift voucher from one of our partnering brands, the Winner will be either be able to redeem the Prize at the specified brand location or instructed to collect the Prize from our offices in Birkirkara, Malta. The Winner is instructed to look at the redeemable location of each Prize in order to determine where to redeem the Prize. If the Prize needs to be collected from our offices in Birkirkara, the Prize must be collected by the actual Winner of the Game. The Winner needs to present the Gift on his/her account on the cloudigo application at the cloudigo offices for the cloudigo Team to scan and validate the Gift together with an identification card.</li>
                                <li>Each Prize has its own expiry date for redemption and is subject to the Gift Vouchers section of the General cloudigo Terms and Conditions found here: <a routerLink="/info/terms-and-conditions">Terms & Conditions</a></li>
                                <li>In the event that the Prize needs to be collected from the cloudigo offices:</li>
                                <li>In the event that the Prize needs to be collected from the cloudigo offices, Winners must not collect their Prize later than sixty (60) days from the winning date. For the avoidance of doubt, if the Winner does not collect the prize within sixty (60) days of winning the prize, the Winner will no longer be eligible to receive the Prize. Upon collection of the Prize/s, cloudigo reserves the right to ask the Winner/s to take a photo with the Prize.</li>
                            </ol>
                        </li>

                        <li>Prizes won cannot be redeemed for cash and are not valid in conjunction with any other offer.</li>

                        <li>A Winner cannot win more than one of the same Prize.</li>

                        <li>Throughout the Duration of the Competition, a Winner, cannot win more than three (3) Prizes</li>

                        <li>The names and/or photos of the Winners, may be announced and/or posted on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a>, the cloudigo application and/or website www.cloudigo.app.</li>
                        
                        <li>The Prize terms and conditions shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>

                        <li>cloudigo ltd reserves the right to substitute the Prize for one of equal value in the event of circumstances beyond its control.</li>

                        <li>cloudigo are in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>

                        <li>The game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.</li>

                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="fragment() == 'christmas-2024'">
                <mat-expansion-panel-header>
                    <h3 id="christmas-2024">cloudigo Campaign - ‘3 Weeks of Christmas Challenges’ December 2024 Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        Between the <span class="font-bold">December 2, 2024</span>, and <span class="font-bold">December 22, 2024</span>, registered users of the cloudigo application may have the opportunity to win one of the many discount codes and gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners by completing a series of specific actions (‘Challenge’) within the cloudigo application. and enter the chance of winning 
                    </p>
                    <ol>
                        <li>The Challenge and/or Mini-Games are open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>Starting from 02/12/2024, there will be a Challenge every week. In total there will be three (3) Challenges spread over a period of three (3) weeks as per below. The overall duration of the Challenge (‘Duration’) is from 02/12/2024 till 22/12/2024

                            <ol>
                                <li>Challenge 1: 02/12/2024 - 08/12/2024</li>
                                <li>Challenge 2: 09/12/2024 - 15/12/2024</li>
                                <li>Challenge 3: 16/12/2024 - 22/12/2024</li>
                            </ol>
                        </li>

                        <li>Participation in the Challenge and/or Mini-Game constitutes participant’s full acceptance of these Rules and Terms & Conditions.</li>

                        <li>To participate in this Challenge and/or Mini-Game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account, participants will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>. The Challenge is available free of charge on the cloudigo application only.</li>

                        <li>
                            Every Week, Participants will be able to participate in a Challenge and perform a set of actions (‘Actions’) indicated on the cloudigo application. These actions will be explained on the cloudigo application itself and include the below.
                            <ol>
                                <li>Invite a Friend</li>
                                <li>Redeem an in-store offer</li>
                                <li>Become a Winner in one of our Mini-Challenges</li>
                                <li>Participate in one of our Mini-Challenges</li>
                            </ol>
                        </li>

                        <li>
                            Every Week, when an action is fulfilled, a number of points (“Tickets”) will be assigned to the Participant. 
                        </li>

                        <li>
                            You can collect tickets for a maximum of three in-store redemptions per day. If you redeem more than three times in a single day, additional redemptions will not earn you extra tickets for the lottery.
                        </li>

                        <li>
                            cloudigo reserves the right to modify and/or revolve the number of Tickets of each Participant if the need arises.
                        </li>

                        <li>
                            cloudigo reserves the right to modify, add or remove the Actions within each Challenge.
                        </li>

                        <li>
                            Every Week, the number of Tickets will start from scratch and a new Challenge will begin. Tickets cannot be carried over from Week to Week. 
                        </li>

                        <li>
                            Every Week, seventeen (17) lucky winners will be chosen at random and will be rewarded accordingly;
                            <ol>
                                <li>The first lucky person to be drawn will win : €200 worth of Prizes</li>
                                <li>The second lucky person to be drawn will win: €100 worth of Prizes</li>
                                <li>The third lucky person to be drawn will win: €60 worth of Prizes</li>
                                <li>The fourth to seventh lucky person to be drawn will each win: €20 worth of Prizes</li>
                            </ol>
                        </li>

                        <li>
                            Furthermore, every Week, Participants who participate in one or more of our Mini-Challenges can also get the chance to win more Prizes.
                        </li>

                        <li>
                            Winning a Prize in the Challenge and/or Mini-Game is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions.
                        </li>

                        <li>
                            Prizes in the Challenge and/or Mini-Game won cannot be redeemed for cash and are not valid in conjunction with any other offer.
                        </li>

                        <li>
                            The Prize terms and conditions in the Challenge and/or Mini-Game shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.
                        </li>

                        <li>
                            cloudigo ltd reserves the right to substitute the Prize in the Challenge and/or Mini-Game for one of equal value in the event of circumstances beyond its control.
                        </li>

                        <li>
                            cloudigo Ltd reserves the right to remove, change or add any of the Prizes in the Challenge and/or Mini-Game. 
                        </li>

                        <li>
                            cloudigo Ltd reserves the right to shorten, extend, suspend and/or modify the Duration of the Challenge and/or Mini-Game at its discretion and at any time.
                        </li>

                        <li>
                            cloudigo Ltd reserves the right to terminate or temporarily suspend the Challenge and/or Mini-Game at any time, for any reason, with or without notice.
                        </li>

                        <li>
                            cloudigo Ltd reserves the right to disqualify any participant or revoke any gift if any abuse is detected.
                        </li>

                        <li>
                            The names of the Winners of the Challenge and/or Mini-Game may be announced on the ‘cloudigo’ social media channels and/or the cloudigo application or website <a routerLink="/">www.cloudigo.app</a>. The Winner/s of the Challenge and/or Mini-Game may be asked for his/her consent to take an official photo with the Prize/s. This may then be posted on the cloudigo Social Media Channels and/or cloudigo app/website subject to said prior consent.
                        </li>

                        <li>
                            cloudigo are in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.
                        </li>

                        <li>
                            The Challenge and/or Mini Game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.
                        </li>

                        <li>
                            The  Challenge and/or Mini-Game shall be subject to our general Terms and Conditions found on our website <a routerLink="/terms">here</a> 
                        </li>

                        <li>
                            The Challenge and/or Mini-Game shall be governed by, and construed in accordance with, the laws of Malta and the Courts of Malta shall have exclusive jurisdiction to determine any dispute in relation hereto.
                        </li>

                        <li>
                            If a Participant is selected as a winner in the Challenge and/or Mini-Game/s  then he or she becomes a winner (‘Winner’). The Prize won by the Winner will be displayed on the cloudigo application itself and the Winner will be instructed on how to obtain the Prize. The Winner/s may be contacted via email, mobile phone (call or SMS)  and/or push notification according to the registered details of the Winner’s account.
                            <ol>
                                <li>
                                    Each Prize has its own expiry date for redemption and is subject to the gift vouchers section of the General cloudigo Terms and Conditions found <a routerLink="/terms">here</a>
                                </li>
                                <li>
                                    If the Winner finds a cloudigo discount code, this will be displayed on the application for you to add to your account. Each cloudigo discount code has its own Terms and Conditions specified on the application and in line with the General Terms of Service and Privacy Policy found on the cloudigo website.
                                </li>
                                <li>
                                    Alternatively, if the Winner finds a gift voucher from one of our partnering brands, the Winner will either be able to redeem the Prize at the specified brand location or instructed to collect the Prize from our offices in Birkirkara, Malta. The Winner is instructed to look at the redeemable location of each Prize in order to determine where to redeem the Prize. In the event that the Prize needs to be collected from the cloudigo offices, Winners must not collect their Prize later than sixty (60) days from the winning date. For the avoidance of doubt, if the Winner does not collect the prize within sixty (60) days of winning the prize, the Winner will no longer be eligible to receive the Prize.
                                </li>
                            </ol>
                        </li>
                    </ol>

                    <table class="by4">
                        <tr>
                          <td class="font-bold">Brand</td>
                          <td class="font-bold">Quantity of Vouchers</td>
                          <td class="font-bold">Value per Voucher</td>
                        </tr>
                        <tr>
                            <td>Alice Pizza</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Aloha</td>
                            <td>5</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Amigos</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>AVON</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>AYU </td>
                            <td>3</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Bata</td>
                            <td>4</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Bistro 516</td>
                            <td>2</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Brillace Cafe</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Cafe Buongiorno</td>
                            <td>5</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Chatterbox</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Chick’n Bites</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Clarks</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Darmanin Footwear</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Deco Manufacturing</td>
                            <td>2</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Distinctive Collection Sliema</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Dr Juice</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Eurosport</td>
                            <td>4</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fat Harry’s</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Food Island</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fred Perry</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fuel & Co</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Gallarija Darmanin</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Good Eats</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Heirloom Streatery</td>
                            <td>2</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>INA SPA</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>IRIS PHOTO ART</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>IT Fish</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>J’Oli</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>JB Stores</td>
                            <td>4</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Jules</td>
                            <td>6</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>KAOS Gastrolounge</td>
                            <td>4</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Krepree</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>KUPS</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>London Gastropub</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Marella</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Martina’s Cafebar</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Matalan</td>
                            <td>5</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Merkanti</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>MEZ</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Miniso</td>
                            <td>4</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Morgan</td>
                            <td>7</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mothercare</td>
                            <td>6</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mumuso</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Must-Haves Malta</td>
                            <td>3</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Muy Mucho</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Norita’s</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Peppi’s</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Plush Mats</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Rainforest Cafe </td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>RASOI</td>
                            <td>2</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Rotunda Cafe Bar</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Rusty Spoon</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>Signature Asian Cafe</td>
                            <td>5</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Sisley</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>SUIGA PPE</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>TALLY WEiJL</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Teamsport</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>The Hoppy Hare</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>The Smokehouse</td>
                            <td>1</td>
                            <td>€20</td>
                        </tr>
                        <tr>
                            <td>The Wild West</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Toy Magic</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Toytastic</td>
                            <td>4</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Xoligo</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Zen Sushi to Go</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                    </table>

                    <br/>

                    <p>
                        <span class="font-bold">Week 1 - cloudigo's Christmas 'Guess the Word' December 2024</span>
                    </p>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the <span class="font-bold">‘cloudigo's Christmas 'Guess the Word' December 2024’</span> (‘Mini-Game 1’) on the cloudigo application, everyday you (‘Participant’) will have a chance to guess the word within the given duration of the Game and will enter the chance of winning one of the gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners
                    </p>

                    <ol>
                        <li>Mini-Game 1 is valid every day (‘Entry’) from 02/12/2024 till 08/12/2024 (‘Duration’). The final closing date is 08/12/2024 at 11:59pm.</li>
                        <li>Throughout the Duration of the Mini-Game, a Winner cannot win more than three (3) Prizes.</li>
                        <li>
                            Every Entry of Mini-Game 1, participants will be able to:
                            <ul>
                                <li>
                                    Observe the four (4) pictures and the respective anagram of the day
                                </li>
                                <li>
                                    Guess the word related to the four (4) pictures. (Participants can try and guess how many times they want)
                                </li>
                                <li>
                                    When the Participant guesses the word, he/she is required to virtually scratch the screen to enter the chance of winning one of the Prizes specified in the Game.
                                </li>
                            </ul>
                        </li>
                    </ol>

                    <table class="by4">
                        <tr>
                          <td class="font-bold">Brand</td>
                          <td class="font-bold">Quantity of Vouchers</td>
                          <td class="font-bold">Value per Voucher</td>
                        </tr>
                        <tr>
                            <td>Aloha</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Amigos</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>AVON</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Brillace Cafe</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Cafe Buongiorno</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Chatterbox</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Chick’n Bites</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Clarks</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Daisy’s Pet Shop</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Darmanin Footwear</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Eurosport</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fat Harry’s</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fred Perry</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fuel & Co</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Gallarija Darmanin</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Good Eats</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>JB Stores</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Jules</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Matalan</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>MEZ</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Miniso</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mothercare</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Muy Mucho</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Norita’s</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Superdry</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Teamsport </td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>The Wild West</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                    </table>

                    <br/>

                    <p>
                        <span class="font-bold">Week 2 - cloudigo's Christmas 'Guess the Word' December 2024</span>
                    </p>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the <span class="font-bold">‘cloudigo's Christmas Quiz December 2024’</span> (‘Mini-Game 2’) on the cloudigo application, everyday you (‘Participant’) will have a chance to answer six (6) questions within the given duration of the Game and will enter the chance of winning one of the gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>

                    <p>
                        In addition to the Terms and Conditions outlined here, Week 2’s Mini-Game will also be governed by the Weekly Quiz Rules and the Terms & Conditions available <a routerLink="/terms" fragment="generic-quiz">here</a>
                    </p>

                    <table class="by4">
                        <tr>
                          <td class="font-bold">Brand</td>
                          <td class="font-bold">Quantity of Vouchers</td>
                          <td class="font-bold">Value per Voucher</td>
                        </tr>
                        <tr>
                            <td>AVON</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Brillace Cafe</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Clarks</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Darmanin Footwear</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fat Harry’s</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fuel & Co</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Gallarija Darmanin</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Hoppy Hare Pub</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>JB Stores</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Jules</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>KAOS Gastrolounge</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Krepree</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Martina’s Cafebar</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>MEZ</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Morgan</td>
                            <td>3</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mothercare</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mumuso</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Muy Mucho</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Norita’s</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Peppi’s</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Superdry</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>TALLY WEiJL</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Teamsport</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>The Wild West</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Xoligo</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Zen Sushi</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                    </table>

                    <p>
                        <span class="font-bold">Week 3 - cloudigo's Christmas Treasure Hunt December 2024</span>
                    </p>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the <span class="font-bold">‘cloudigo's Christmas Treasure Hunt December 2024’</span> (‘Mini-Game 3’) on the cloudigo application, you (‘Participant’) will be able to open a box linked to that particular day in order to reveal a clue. The clue will aid you in finding the missing sticker of that particular day and enter the chance of winning one of the many discount codes and gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>

                    <ol>
                        <li>Mini-Game 3 is valid every day (‘Entry’) from 16/12/2024 till 22/12/2024 (‘Duration’). The final closing date for competition is 22/12/2024 at 11.59pm.</li>
                        <li>Throughout the Duration of the Competition, a Winner, cannot win more than three (3) Prizes.</li>
                        <li>
                            Every Entry, Participants will be able to:
                            <ul>
                                <li>
                                    Open the box of that particular day in order to reveal a clue.
                                </li>
                                <li>
                                    Once the clue is revealed, the Participant needs to browse the app and locate the missing sticker.
                                </li>
                                <li>
                                    When the Participant finds the missing sticker, they are required to virtually scratch the screen to enter the chance of winning one of the Prizes specified in the Game. If the Participant fails to open one of the previous boxes prior to that day, the Participant will have the opportunity to open them anyway. Winning a prize is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions.
                                </li>
                            </ul>
                        </li>
                    </ol>

                    <table class="by4">
                        <tr>
                          <td class="font-bold">Brand</td>
                          <td class="font-bold">Quantity of Vouchers</td>
                          <td class="font-bold">Value per Voucher</td>
                        </tr>
                        <tr>
                            <td>AVON</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Chatterbox</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Chick’n Bites</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Darmanin Footwear</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Food Island</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Fred Perry</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>IT Fish</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Jules </td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>KAOS Gastrolounge</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>KUPS</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Marella</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Martina’s Cafebar</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Matalan</td>
                            <td>2</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Miniso</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Morgan</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mothercare</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Mumuso</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Sisley</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Superdry</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>TALLY WEiJL</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>The Wild West</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Toy Magic</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Toytastic</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                        <tr>
                            <td>Zen Sushi</td>
                            <td>1</td>
                            <td>€10</td>
                        </tr>
                    </table>
                    <br/>
                    <br/>

                </ng-template>
            </mat-expansion-panel>
     
            <mat-expansion-panel [expanded]="fragment() == 'just-scan'">
                <mat-expansion-panel-header>
                    <h3 id="just-scan">Just Scan the Receipt Campaign Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        CassarCamilleri Marketing, Sales & Distribution Ltd (C 20060) of “The Winery”, Wills Street,
                        Paola, Malta (the ‘Organiser’), shall be organising a Campaign by the name of ‘<span class="font-bold">Just Scan the Receipt Campaign</span>’, under MGA permit number: MGA/CCG/051/2024.
                        
                        <br/><br/>

                        The Campaign is effective from July 15th, 2024 until October 15th, 2024.

                        <br/><br/>

                        Participants need to be of 18 years and over and can take part in the Campaign by following these steps:

                    </p>

                    <ol class="sublisted">
                        <li>
                            Visiting any one of:
                            <br/><br/>
                            <ul class="sublisted" type="i">
                                <li>
                                    Smart (Naxxar Road, Birkirkara),
                                </li>
                                <li>
                                    Pama (Triq Valletta, Mosta), 
                                </li>
                                <li>
                                    Pavi (Manuel Dimech Street, Qormi) OR
                                </li>
                                <li>
                                    Welbee’s outlets (Welbee’s Balluta- Triq Borg Olivier, St. Julians; Welbee’s Mellieha- Triq il-Kbira, Mellieha; Welbee’s Naxxar- Parish Street, Naxxar; Welbee’s Paceville- Triq Gort, Paceville; Welbee’s Qawra- Triq il-Merluzz, Qawra; Welbee’s Sliema- High Street, Sliema; Welbee’s Spinola- Spinola Park, St. Julian’s,  Welbee’s Santa Venera- Old Railway Track, Santa Venera, Welbee’s Campus- University of Malta, Tal-Qroqq, Msida, Welbee’s Shoreline- The Shoreline mall, Smart City, Kalkara).
                                </li>
                            </ul>
                            <br/>
                        </li>
                        <li>
                            Purchasing therefrom any one or more of the Just Squashes and/or Just Milk mixers listed hereunder:
                            <br/><br/>
                            <ol class="sublisted">
                                <li>Just Bubblelicious Milk Mixer 1L</li>
                                <li>Just Chocoholic Milk Mixer 1L</li>
                                <li>Just Sensational Milk Mixer 1L</li>
                                <li>Just Strawberry Bliss Milk Mixer 1L</li>
                                <li>Just Bananas Milk Mixer 1L</li>
                                <li>Just Orange Squash 1L</li>
                                <li>Just Lemon Squash 1L</li>
                                <li>Just Red Apple Squash 1L</li>
                                <li>Just Peach Squash 1L</li>
                                <li>Just Tangerine Squash 1L</li>
                                <li>Just Orzata Squash 1L</li>
                                <li>Just Blackcurrant Squash 1L</li>
                                <li>Just Peach Squash Ice Tea 1L</li>
                                <li>Just Lime Flavoured Squash 1L</li>
                                <li>Just Orange Squash Light 1L</li>
                                <li>Just Orzata Squash Light 1L</li>
                                <li>Just Chocolate Milk Mixer 1L</li>
                            </ol>
                            <br/>
                        </li>
                        <li>
                            Scanning the relative receipts using the Cloudigo Application:
                            <br/>
                            Once a Participant scans the receipt, this will be processed by the Application which will display a message on the screen that will inform Participants whether they have won a Prize or not. In certain cases, this may take a few hours. If issues are encountered while scanning the receipt, you can contact the Application providers on <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>. If after the second try, the Participant still experiences some form of error when submitting the receipt on the Cloudigo Platform even though the receipt is valid, the Participant will have the option to submit the receipt for manual verification.
                        </li>
                    </ol>

                    <p>
                        The prizes for the Campaign are:
                    </p>
                    <ul>
                        <li>
                            Four (4) PS5 Slim (Disc Version) (1 Year Guarantee) 
                        </li>
                        <li>
                            Seven (7) Kieslect Smart Calling Watch KR2 
                        </li>
                        <li>
                            Fifteen (15) Xiaomi LCD Writing Tablet
                        </li>
                        <li>
                            One hundred (100) €20 Vouchers from Forestals
                        </li>
                    </ul>

                    <p>
                        Conditions:

                        <br/><br/>

                        By accepting to participate in the Campaign, participants agree and declare to fully understand the following:
                    </p>

                    <ol class="sublisted" type="a">
                        <li>Receipts deemed invalid for any reason, will be automatically disqualified and excluded from the prize draw;</li>
                        <li>The Organiser reserves the right, at its sole discretion, to change the prizes during the Campaign however any such changes will appear on the Cloudigo Application;</li>
                        <li>The Organiser shall at no stage of the participants' taking part in the Campaign be held responsible for any losses and/or damages ofwhatever nature he/she might incur as a result of his/her participation in the Campaign</li>
                        <li>Prizes cannot be transferred to third parties and/or exchanged with other items, and/or exchanged for cash;</li>
                        <li>The Organiser shall not in any way be held liable by winning participants for any defect, whether latent or otherwise, in any of the prizes distributed to winning participants;</li>
                        <li>The prizes and vouchers can be collected from The Master Cellar in Naxxar (40, Triq lOratorju, In-Naxxar). The opening hours of the outlet being:

                            <br/><br/>
                            Monday to Saturday from 9am to 7pm and Sundays from 9am to 12.30pm.
                            <br/>
                            During public holidays the outlet is open from 9am to 12.30pm.
                        </li>
                        <li>
                            The prizes can be collected <span class="font-bold">only</span> up until the 30th November 2024. Failure to do so within the time period herein specified will automatically result in the forfeiture of the Prize.
                        </li>
                        <li>Vouchers cannot be used in conjunction with other offers or exchanged for cash</li>
                        <li>The Winner/s may be asked for his/her consent to take an official photo with the Prize/s. This may then be posted on the cloudigo and/or Just Social Media Channels and/or cloudigo app/website subject to said prior consent.</li>
                        <li>These Terms and Conditions are to be read and understood in conjunction with the terms and conditions applicable to the registration of an account on the Cloudigo application (the “Application”) which are available at <a routerLink="/info/terms-and-conditions">https://www.cloudigo.app/info/terms-and-conditions</a> and the privacy notice available at <a routerLink="/info/privacy-policy">https://www.cloudigo.app/info/privacy-policy</a>.</li>
                    </ol>

                    <p>
                        OTHER CONDITIONS:
                    </p>

                    <ul>
                        <li>Once a Participant scans the receipt, this will be processed by the Application which will display a message on the screen that will inform Participants whether they have won a Prize or not. In certain cases, this may take a few hours. If issues are encountered while scanning the receipt, you can contact the Application providers on <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>. The winners will be chosen at random throughout the campaign through the platform’s certified randomiser. </li>
                        <li>If the original receipt is long and cannot be captured in a single scan, participants are kindly requested to scan multiple parts of the receipt and upload them accordingly on the Application.</li>
                        <li>The original receipt scanned on the Application will be processed and stored on the Application for an additional two (2) months from the end of the Campaign.</li>
                        <li>Participation through the Application is free of charge.</li>
                        <li>A Participant is not precluded from winning more than one prize during the Campaign period.</li>
                        <li>Each Prize (Excluding the 20 euro Forestals vouchers) may only be won once per participant or account.</li>
                        <li>The Prizes and their respective terms and conditions are listed on the Application.</li>
                        <li>Once a Participant wins a prize, the prize will be automatically added as a voucher in digital format on the Participant’s profile of the Application. Participants may redeem the Prizes as indicated on the Application and are subject to the terms and conditions. Winners will be required to present the Prize on the Application at the redemption location. Failure to do so will result in the forfeiture of the Prize.</li>
                        <li>Each Prize may be subject to a specific validation process. This includes scanning the QR code provided by the merchant of the Prize via the Application or having the merchant insert a pincode in the Application to validate the Prize. The merchant may also need to scan the barcode or code displayed on the Participant’s Application for verification purposes.</li>
                        <li>The Organiser reserves the right to shorten, extend, and/or suspend the Campaign Period orotherwise modify the Campaign Period at its discretion and at any time.</li>
                        <li>The Organiser reserves the right to terminate or temporarily suspend the Campaign at any time,for any reason, with or without notice.</li>
                        <li>The Organiser reserves the right to modify any of the terms and conditions at any time.</li>
                        <li>These terms shall be governed by, and construed in accordance with, the laws of Malta and the Courts of Malta shall have exclusive jurisdiction to determine any dispute in relation hereto.</li>
                    </ul>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="fragment() == 'easter-4P1W'">
                <mat-expansion-panel-header>
                    <h3 id="easter-4P1W">cloudigo's Easter Quest 'Guess the Word' Game March 2024 Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the ‘<span color="primary">cloudigo's Easter Quest 'Guess the Word' Game March 2024</span>’ (‘Game’) on the cloudigo application, everyday you (‘Participant’) will have a chance to answer three (3) questions in our quiz Game within the given duration of the Game and will enter the chance of winning one of the gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>
                    <ol >
                        <li>The Game is open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>The game is valid every day (‘Entry’) from 18/03/2024 till 31/03/2024 (‘Duration’). The final closing date for competition is 31/03/2024 at 11:59pm.</li>

                        <li>Participation in the game constitutes participant’s full acceptance of these Rules and Terms & Conditions. Winning a prize is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions.</li>

                        <li>To participate in this Game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account, Participant will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>.</li>

                        <li>The Game is available on the cloudigo application only.</li>

                        <li>Every Entry, participants will be able to:
                            <ol>
                                <li>Observe the four (4) pictures and the respective anagram of the day</li>
                                <li>Guess the word related to the four (4) pictures. (Participants can try and guess how many times they want)</li>
                                <li>When the Participant guesses the word, he/she is required to virtually scratch the screen to enter the chance of winning one of the Prizes specified in the Game.</li>
                            </ol>
                        </li>

                        <li>In total there are <span class="font-bold">one hundred and five (105) Prizes</span> to be won as shown below.
                            <ol>
                                <li>Fourteen <span class="font-bold">(14)</span> cloudigo discount codes by Cloudigo Ltd entitling the user to a free twelve (12) months on the cloudigo Premium Yearly Plan each valued at forty-seven euros and eighty-eight cents <span class="font-bold">(€47.88)</span></li>
                                <li>Twenty-two <span class="font-bold">(22)</span> cloudigo discount codes by Cloudigo Ltd entitling the user to a fifty percent (50%) OFF on the cloudigo Premium Yearly Plan. The discount is equivalent to twenty-three euros and ninety-eight four <span class="font-bold">(€23.94)</span>
                                </li>
                                <li>Twenty <span class="font-bold">(20)</span> ten euro <span class="font-bold">(€10)</span> vouchers from one of the following brands:</li>
                                <ul>
                                    <li>Aloha</li>
                                    <li>Brillace</li>
                                    <li>Fred Perry</li>
                                    <li>Fuel & Co</li>
                                    <li>Marella</li>
                                    <li>UPIM</li>
                                </ul>
                                <li>Ten <span class="font-bold">(10)</span> vouchers containg free meals or food from one of the following brands:</li>
                                <ul>
                                    <li>Marrobbio (2 Free Pizzas)</li>
                                    <li>Pastaus (2 Free Plates of Pasta)</li>
                                </ul>
                            </ol>
                        </li>

                        <li>If a Participant finds a Prize whilst playing this Game, then he or she becomes a winner (‘Winner’). The Prize won by the Winner will be displayed on the cloudigo application itself and the Winner will be instructed on how to obtain the Prize.
                            <ol>
                                <li>If the Winner finds a cloudigo discount code, this will be displayed on the application for you to add to your account. Each cloudigo discount code has its own Terms and Conditions specified on the application and in line with the General Terms of Service and Privacy Policy found on the cloudigo website.</li>
                                <li>Alternatively, if the Winner finds a gift voucher from one of our partnering brands, the Winner will be either be able to redeem the Prize at the specified brand location or instructed to collect the Prize from our offices in Birkirkara, Malta. The Winner is instructed to look at the redeemable location of each Prize in order to determine where to redeem the Prize.</li>
                                <li>Each Prize has its own expiry date for redemption and is subject to the Gift Vouchers section of the General cloudigo Terms and Conditions found <a routerLink="/info/terms-and-conditions">here</a></li>
                            </ol>
                        </li>

                        <li>In the event that the Prize needs to be collected from the cloudigo offices:
                            <ol>
                                <li>The Prize delivery arrangements will be conducted via mobile phone or email. You should ensure that your registration details are correct and up to date as otherwise we may not be able to reach you.</li>
                                <li>The Prize shall be collected from cloudigo's offices. Winners must not collect their Prize later than sixty (60) days from the winning date. For the avoidance of doubt, if the Winner does not collect the prize within sixty (60) days of winning the prize, the Winner will no longer be eligible to receive the Prize.</li>
                            </ol>
                        </li>

                        <li>Prizes won cannot be redeemed for cash and are not valid in conjunction with any other offer.</li>

                        <li>A Winner cannot win more than one of the same Prize.</li>

                        <li>Throughout the Duration of the Competition, a Winner, cannot win more than three (3) Prizes.</li>

                        <li>Every Entry, the names of the Winners of the previous day, may be announced on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a> and/or the cloudigo application or website www.cloudigo.app.</li>
                        
                        <li>The names of the Winners may be announced on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a> and/or the cloudigo application or website www.cloudigo.app.</li>

                        <li>The Prize terms and conditions shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>

                        <li>cloudigo ltd reserves the right to substitute the Prize for one of equal value in the event of circumstances beyond its control.</li>

                        <li>cloudigo are in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>

                        <li>The game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.</li>

                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="fragment() == 'valentine-4pics1word-2024'">
                <mat-expansion-panel-header>
                    <h3 id="valentine-4pics1word-2024">cloudigo's Valentine 'Can you guess the word?' Game February 2024 Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the ‘<span color="primary">cloudigo’s Valentine ‘Guess the Word’ Game February 2024</span>’ (‘Game’) on the cloudigo application, everyday you (‘Participant’) will have a chance to answer three (3) questions in our quiz Game within the given duration of the Game and will enter the chance of winning one of the gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>
                    <ol >
                        <li>The Game is open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>The game is valid every day (‘Entry’) from 12/02/2024 till 29/02/2024 (‘Duration’). The final closing date for competition is 29/02/2024 at 11:59pm.</li>

                        <li>Participation in the game constitutes participant’s full acceptance of these Rules and Terms & Conditions. Winning a prize is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions.</li>

                        <li>To participate in this Game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account, Participant will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>.</li>

                        <li>The Game is available on the cloudigo application only.</li>

                        <li>Every Entry, participants will be able to:
                            <ol>
                                <li>Observe the four (4) pictures and the respective anagram of the day</li>
                                <li>Guess the word related to the four (4) pictures. (Participants can try and guess how many times they want)</li>
                                <li>When the Participant guesses the word, he/she is required to virtually scratch the screen to enter the chance of winning one of the Prizes specified in the Game.</li>
                            </ol>
                        </li>

                        <li>In total there are <span class="font-bold">one hundred and five (105) Prizes</span> to be won as shown below.
                            <ol>
                                <li>Fifteen <span class="font-bold">(15)</span> cloudigo discount codes by Cloudigo Ltd entitling the user to a free twelve (12) months on the cloudigo Premium Yearly Plan each valued at forty-seven euros and eighty-eight cents <span class="font-bold">(€47.88)</span></li>
                                <li>Thirty <span class="font-bold">(30)</span> cloudigo discount codes by Cloudigo Ltd entitling the user to a fifty percent (50%) OFF on the cloudigo Premium Yearly Plan. The discount is equivalent to twenty-three euros and ninety-eight four <span class="font-bold">(€23.94)</span>
                                </li>
                                <li>Twenty-three <span class="font-bold">(23)</span> ten euro <span class="font-bold">(€10)</span> vouchers from one of the following brands:</li>
                                <ul>
                                    <li>Brown's Kitchen</li>
                                    <li>Darmanin Footwear</li>
                                    <li>JB Stores</li>
                                    <li>Gallarija Darmanin</li>
                                    <li>Miniso</li>
                                    <li>Mothercare</li>
                                    <li>Solaris</li>
                                </ul>
                                <li>Thirty-seven <span class="font-bold">(37)</span> vouchers containg free meals or food from one of the following brands:</li>
                                <ul>
                                    <li>Brasa (Free Meal)</li>
                                    <li>NOM NOM (2 Free Pizzas)</li>
                                    <li>Wok to Walk (Free Noodles)</li>
                                </ul>
                            </ol>
                        </li>

                        <li>If a Participant finds a Prize whilst playing this Game, then he or she becomes a winner (‘Winner’). The Prize won by the Winner will be displayed on the cloudigo application itself and the Winner will be instructed on how to obtain the Prize.
                            <ol>
                                <li>If the Winner finds a cloudigo discount code, this will be displayed on the application for you to add to your account. Each cloudigo discount code has its own Terms and Conditions specified on the application and in line with the General Terms of Service and Privacy Policy found on the cloudigo website.</li>
                                <li>Alternatively, if the Winner finds a gift voucher from one of our partnering brands, the Winner will be either be able to redeem the Prize at the specified brand location or instructed to collect the Prize from our offices in Birkirkara, Malta. The Winner is instructed to look at the redeemable location of each Prize in order to determine where to redeem the Prize.</li>
                                <li>Each Prize has its own expiry date for redemption and is subject to the Gift Vouchers section of the General cloudigo Terms and Conditions found <a routerLink="/info/terms-and-conditions">here</a></li>
                            </ol>
                        </li>

                        <li>In the event that the Prize needs to be collected from the cloudigo offices:
                            <ol>
                                <li>The Prize delivery arrangements will be conducted via mobile phone or email. You should ensure that your registration details are correct and up to date as otherwise we may not be able to reach you.</li>
                                <li>The Prize shall be collected from cloudigo's offices. Winners must not collect their Prize later than sixty (60) days from the winning date. For the avoidance of doubt, if the Winner does not collect the prize within sixty (60) days of winning the prize, the Winner will no longer be eligible to receive the Prize.</li>
                            </ol>
                        </li>

                        <li>Prizes won cannot be redeemed for cash and are not valid in conjunction with any other offer.</li>

                        <li>A Winner cannot win more than one of the same Prize.</li>

                        <li>Throughout the Duration of the Competition, a Winner, cannot win more than three (3) Prizes.</li>

                        <li>Every Entry, the names of the Winners of the previous day, may be announced on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a> and/or the cloudigo application or website www.cloudigo.app.</li>
                        
                        <li>The names of the Winners may be announced on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a> and/or the cloudigo application or website www.cloudigo.app.</li>

                        <li>The Prize terms and conditions shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>

                        <li>cloudigo ltd reserves the right to substitute the Prize for one of equal value in the event of circumstances beyond its control.</li>

                        <li>cloudigo are in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>

                        <li>The game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.</li>

                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="fragment() == 'xmas_hunt_23'">
                <mat-expansion-panel-header>
                    <h3 id="xmas_hunt_23">cloudigo’s Christmas Treasure Hunt December 2023 Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">Instructions: </span>
                        By participating in the ‘<span color="primary">cloudigo’s Christmas Treasure Hunt December 2023</span>’ (‘Game’) on the cloudigo application, you (‘Participant’) will be able to open a box linked to that particular day in order to reveal a clue. The clue will aid you in finding the missing sticker of that particular day and enter the chance of winning one of the many discount codes and gift vouchers (‘Prizes’) from cloudigo ltd (C89187) or one of its co-sponsoring partners.
                    </p>
                    <ol >
                        <li>The Game is open to anyone aged eighteen (18) or over, excluding employees of cloudigo ltd, their agents or families or anyone else connected with the game.</li>

                        <li>The game is valid every day (‘Entry’) from 01/12/2023 till 25/12/2023 (‘Duration’). The final closing date for competition is 25/12/2023 at 11.59pm.</li>

                        <li>Participation in the game constitutes participant’s full acceptance of these Rules and Terms & Conditions. </li>

                        <li>To participate in this game, participants must have downloaded the cloudigo application and registered an account on the cloudigo application. By downloading the cloudigo application and registering for an account Participant will be asked to accept cloudigo’s General <a routerLink="/info/terms-and-conditions">Terms & Conditions</a> and <a routerLink="/info/privacy-policy">Privacy Policy</a>.</li>

                        <li>The Game is available on the cloudigo application only. </li>

                        <li>Every Entry, Participants will be able to: 
                            <ol>
                                <li>Open the box of that particular day in order to reveal a clue.</li>
                                <li>Once the clue is revealed, the Participant needs to browse the app and locate the missing sticker.</li>
                                <li>When the Participant finds the missing sticker, they are required to virtually scratch the screen to enter the chance of winning one of the Prizes specified in the Game. If the Participant fails to open one of the previous boxes prior to that day, the Participant will have the opportunity to open them anyway. Winning a prize is contingent upon the participant fulfilling all requirements set forth in these Rules and Terms and Conditions.</li>
                            </ol>
                        </li>

                        <li>In total there are <span class="font-bold">one thousand, seven hundred and fifty-five (1755) Prizes</span> to be won as shown below:
                            <ol>
                                <li>One Hundred (100) cloudigo discount codes by Cloudigo Ltd entitling the user to a free twelve (12) months on the cloudigo Premium Yearly Plan each valued at forty-seven euros and eighty-eight cents (€47.88)</li>
                                <li>One Thousand and Four Hundred (1400) cloudigo discount codes by Cloudigo Ltd entitling the user to a fifty percent (50%) OFF on the cloudigo Premium Yearly Plan. The discount is equivalent to twenty-three euros and ninety-four cents (€23.94)</li>
                                <li>Two Hundred and Fifteen (215) ten-euro (€10) each from one of the following brands: </li>
                                <ul>
                                    <li>Alice Pizza</li>
                                    <li>Amigos</li>
                                    <li>Bites</li>
                                    <li>Cameleon Rodizio & Grill</li>
                                    <li>Coccinelle</li>
                                    <li>Daisy's Pet Shop</li>
                                    <li>Dr Juice</li>
                                    <li>Fat Harry's</li>
                                    <li>Gallarija Darmanin</li>
                                    <li>Hard Rock Cafe</li>
                                    <li>Highglow Smiles</li>
                                    <li>Il-Forn ta' l-Ghawdxi</li>
                                    <li>Ina Spa</li>
                                    <li>J'Oli</li>
                                    <li>JB Stores</li>
                                    <li>Jules</li>
                                    <li>Kebab Factory</li>
                                    <li>Krepree</li>
                                    <li>Lipsy</li>
                                    <li>Manouche</li>
                                    <li>Marella</li>
                                    <li>Matalan</li>
                                    <li>Miniso</li>
                                    <li>Miracle's Lounge</li>
                                    <li>Morgan</li>
                                    <li>Mothercare</li>
                                    <li>Mumuso</li>
                                    <li>Muy Mucho</li>
                                    <li>Okurama</li>
                                    <li>OPA</li>
                                    <li>Rainforest Cafe</li>
                                    <li>Rendez-Vous</li>
                                    <li>Rotunda Cafe Bar</li>
                                    <li>Solaris</li>
                                    <li>Soul Kitchen</li>
                                    <li>Superdry</li>
                                    <li>Teamsport</li>
                                    <li>The Store</li>
                                    <li>UPIM</li>
                                    <li>Victoria Gastropub</li>
                                    <li>YAMI YABI</li>
                                </ul>
                                <li>Thirty (30) free pizza/noodles vouchers from one of the following brands: </li>
                                <ul>
                                    <li>Il-Girbi</li>
                                    <li>Nom Nom</li>
                                    <li>Wok to Walk</li>
                                </ul>
                                <li>Ten (10) twenty-euro (€20) vouchers from one of the following brands: </li>
                                <ul>
                                    <li>Balanced Healthcare</li>
                                    <li>Merkanti</li>
                                    <li>Rendez-Vous</li>
                                    <li>Rotunda Café Bar</li>
                                    <li>Veranda Fusion</li>
                                </ul>
                            </ol>
                        </li>
                        <li>If a Participant finds a Prize whilst playing this Game, then he or she becomes a winner (‘Winner’). The Prize won by the Winner will be displayed on the cloudigo application itself and the Winner will be instructed on how to obtain the Prize.
                            <ol>
                                <li>If the Winner finds a cloudigo discount code, this will be displayed on the application for you to add to your account. Each cloudigo discount code has its own Terms and Conditions specified on the application and in line with the General Terms of Service and Privacy Policy found on the cloudigo website.</li>
                                <li>Alternatively, if the Winner finds a gift voucher from one of our partnering brands, the Winner will be either be able to redeem the Prize at the specified brand location or instructed to collect the Prize from our offices in Birkirkara, Malta. The Winner is instructed to look at the redeemable location of each Prize in order to determine where to redeem the Prize. If the Prize needs to be collected from our offices in Birkirkara, the Prize must be collected by the actual Winner of the Game. The Winner needs to present the Gift on his/her account on the cloudigo application at the cloudigo offices for the cloudigo Team to scan and validate the Gift together with an identification card.</li>
                                <li>Each Prize has its own expiry date for redemption and is subject to the Gift Vouchers section of the General cloudigo Terms and Conditions found here: <a routerLink="/info/terms-and-conditions">Terms & Conditions</a></li>
                                <li>In the event that the Prize needs to be collected from the cloudigo offices:</li>
                                <li>In the event that the Prize needs to be collected from the cloudigo offices, Winners must not collect their Prize later than sixty (60) days from the winning date. For the avoidance of doubt, if the Winner does not collect the prize within sixty (60) days of winning the prize, the Winner will no longer be eligible to receive the Prize. Upon collection of the Prize/s, cloudigo reserves the right to ask the Winner/s to take a photo with the Prize.</li>
                            </ol>
                        </li>

                        <li>Prizes won cannot be redeemed for cash and are not valid in conjunction with any other offer.</li>

                        <li>A Winner cannot win more than one of the same Prize.</li>

                        <li>Throughout the Duration of the Competition, a Winner, cannot win more than three (3) Prizes</li>

                        <li>The names and/or photos of the Winners, may be announced and/or posted on the ‘cloudigo’ social media channels <a href="https://www.facebook.com/cloudigo" target="_blank">www.facebook.com/cloudigo</a>, the cloudigo application and/or website www.cloudigo.app.</li>
                        
                        <li>The Prize terms and conditions shall also apply. Any complaints regarding the Prize must be addressed directly to cloudigo or the co-sponsoring partner providing the Prize as the case may be.</li>

                        <li>cloudigo ltd reserves the right to substitute the Prize for one of equal value in the event of circumstances beyond its control.</li>

                        <li>cloudigo are in no way affiliated with Apple Inc or Google Inc. All brand names are trademarks or registered trademarks, trade names of their respective companies.</li>

                        <li>The game is sponsored by cloudigo and neither Apple Inc nor Google Inc is the sponsor nor connected in any way, shape or form with this game.</li>

                    </ol>
                </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="fragment() == 'monster-scan'">
                <mat-expansion-panel-header>
                    <h3 id="monster-scan">cloudigo x Monster Energy Campaign - Scan and Win Rules and Terms & Conditions</h3>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p>
                        <span class="font-bold">MGA Permit: [MGA/CCG/040/2023]</span>
                        <br/><br/>

                        Terms & Conditions applicable to Participants in the <span class="font-bold">"[Monster Consumer Promotion]"</span>
                        <br/><br/>

                        These Terms and Conditions (the "<span class="font-bold">Terms and Conditions</span>") are subject to the terms and conditions applicable to the registration of an account on the cloudigo application (the "<span class="font-bold">Application</span>") which are available at <a routerLink="/info/terms-and-conditions">https://www.cloudigo.app/info/terms-and-conditions</a> and the privacy notice available at <a routerLink="/info/privacy-policy">https://www.cloudigo.app/info/privacy-policy</a>. In case of inconsistencies between these Terms and Conditions and the terms and conditions applicable to the registration of an account on the Application or the privacy notice, these Terms and Conditions shall prevail.
                        <br/><br/>

                        The Monster Consumer Promotion (the "<span class="font-bold">Campaign</span>") is a campaign being organised by GSD Marketing LTD (C 3774) (the "<span class="font-bold">Organiser</span>"). Participation in the Campaign is subject to acceptance of these Terms and Conditions.
                        <br/><br/>

                        <span class="font-bold">Duration of Campaign</span>
                    </p>

                    <ol class="sublisted" #list1>
                        <li>The Campaign shall commence on 1st August 2023 and shall end on 30th November 2023, both dates included (the "<span class="font-bold">Promotion Period</span>"). The Organiser reserves the right to shorten, extend, and/or suspend the Promotion Period or otherwise modify or cancel the Promotion Period at its discretion and at any time.</li>
                    </ol>

                    <p>
                        <span class="font-bold">Eligibility and Participation</span>
                    </p>

                    <ol class="sublisted" #list2 start="{{list1.children.length+1}}">
                        <li>To participate in the Campaign and be eligible to win, participants must be eighteen (18) years of age and older, with a valid identity card (the "<span class="font-bold">Participants</span>" and "<span class="font-bold">Participant</span>" shall be construed accordingly), provided that employees of the Organiser, their family members, and persons in any way connected with the Campaign shall not be eligible to participate in the Campaign.</li>

                        <li>In order to participate in the Campaign, participants must;
                            
                            <ol class="sublisted" type="a">
                                <li>Visit the following outlet depending on the month:
                                    <ol class="sublisted" type="i">
                                        <li>Maypole (August)</li>
                                        <li>The Convience Shop (September)</li>
                                        <li>Welbee's Supermarket (October)</li>
                                        <li>PAVI/PAMA (November)</li>
                                    </ol>
                                </li>

                                <li>Purchase at least one 50cl of 'Monster' energy drink (the "<span class="font-bold">Product</span>")</li>

                                <li>scan the original receipt through the Application after having downloaded the Application from the Google play store or the Apple App store and registering an account ("<span class="font-bold">Account</span>")</li>
                            </ol>
                            
                        </li>

                        <li>The Organiser may add or remove products at any time during the Campaign.</li>

                        <li>Participants are Required to keep the original receipt in good order to participate in the Campaign and validate their winnings.</li>

                        <li>Once a Participant scans the receipt, this will be processed by the Application which will display a message on the screen that will inform Participants whether they have won a Prize or not. In certain cases, this may take a few hours. If issues are encountered while scanning the receipt, you can contact the Application providers on <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>.</li>

                        <li>If the original receipt is long and cannot be captured in a single scan, participants are kindly requested to contact cloudigo.</li>

                        <li>The original receipt scanned on the Application will be processed and stored on the Application for an additional two (2) months from the end of the Campaign.</li>

                        <li>Participation through the Application is free of charge.</li>

                        <li>A participant is not precluded from winning more than one Prize during the Promotion Period.</li>

                        <li>Receipts are void if: (a) they are not obtained in accordance with these Terms and Conditions and/or through legitimate channels; and, or(b) any part of the receipt is counterfeit, altered, defective, tampered with or irregular in any way.</li>

                        <li>If a Participant believes that a receipt was not properly validated by the Application, the Participant must notify the Organiser within (15) days from the date of the receipt, but in no case not later than the Promotion Should this case arise, the Organiser will request the Participant to present the original receipt.</li>

                    </ol>

                    <p>
                        <span class="font-bold">The Prizes and Redemption Prizes</span>
                    </p>

                    <ol class="sublisted" #list3 start="{{list1.children.length+list2.children.length+1}}">
                        <li>The prizes which are available to be won during the Promotion Period include the following:
                            
                            <ol class="sublisted" type="a">
                                <li>Eight (8) Monster mini coolers</li>
                                <li>Twenty-five (25) Cloudigo Premium Yearly subscription (1 Year).</li>
                                <li>One Hundred (100) Monster gaming headphones</li>
                                <li>One Hundred (100) ZIGGY Memberships</li>
                                <li>One Hundred (100) Defected Festival Tickets</li>
                            </ol>

                            hereinafter collectively referred to as the "<span class="font-bold">Prizes</span>".  The Prizes set out under clauses 12.3 and 12.4 shall hereinafter be referred to as the "<span class="font-bold">Vouchers</span>".
                            ZIGGY memberships to be redeemable by 7th September 2023. Those who are to redeem the membership will receive Pit Pass Christina Aguilera tickets instead.    
                        </li>

                        <li>The Organiser reserves the right to modify the available Prizes at its discretion and at any time during the Campaign.</li>

                        <li>The Prizes and their respective terms and conditions of the applicable merchant or trader are listed on the Application.</li>

                        <li>Participants may redeem the Prizes (other than the Vouchers) at any time during and/or after the Promotion Period subject to the terms and conditions for each Prize which will be displayed on the cloudigo application.</li>

                        <li>The Prizes will be on a first come, first served basis for as long as stocks last. The Organiser shall be under no obligation to re-stock any of the Prizes. Should a Prize be out of stock or otherwise unavailable at the time in which the Participant chooses to redeem it, the Participant will be notified. The Organiser shall not be liable should a Prize be unavailable at the time of redemption and/or order.</li>

                        <li>Once a Participant wins a Voucher, the Voucher will be automatically added in digital format on the Participant’s profile of the Application. Participants may redeem the Vouchers at any time during and/or after the Promotion Period subject to the terms and conditions for each Voucher. The winner will be required to present the Voucher at the redemption location. Failure to present the Voucher will result in the forfeit of the Prize.</li>

                        <li>Each Voucher may be subject to a specific validation process. This includes scanning the  QR code provided by the merchant of the Voucher via the Application or having the merchant insert a pin-code in the Application to validate the Voucher. The merchant may also need to scan the barcode or code displayed on the Participant’s Application for verification purposes.</li>

                        <li>Prizes may not be exchanged for any other Prize or for cash, and may not be transferred or assigned. All Prize redemptions are final. Refunds, exchanges, and other matters in connection with the Prizes are governed by the terms and conditions of the merchant and are not the responsibility of the Organiser.</li>

                        <li>The Organiser shall not be responsible for defective Prizes.</li>

                    </ol>

                    <p>
                        <span class="font-bold">Modifications and Termination of the Campaign</span>
                    </p>

                    <ol class="sublisted" #list4 start="{{list1.children.length+list2.children.length+list3.children.length+1}}">
                        <li>The Organiser reserves the right to shorten, extend, and/or suspend the Promotion Period or otherwise modify the Promotion Period at its discretion and at any time.</li>

                        <li>The Organiser reserves the right to modify any of the terms and conditions set forth in these Terms and Conditions at its sole direction, at any time with or without notice and liability to Participants, including but not limited to modifications relating to the Product, the methods by which Participants can win and redeem the Prizes, and the available Prizes.</li>

                        <li>The Organiser reserves the right to terminate or temporarily suspend the Campaign at any time, for any reason, with or without notice, even though the termination may affect a Participant’s ability to participate in the Campaign.</li>

                        <li>A Participant’s participation in the Campaign constitutes the Participant’s acceptance to these Terms and Conditions as may be amended from time to time. Participants are responsible for keeping up to date with any changes that the Organiser may have made to these Terms and Conditions. The most current version of the Terms and Conditions will be made available on the Application and will supersede all previous versions of these Terms and Conditions. </li>
                    </ol>

                    <p>
                        <span class="font-bold">General Terms and Conditions</span>
                    </p>
                    <ol class="sublisted" #list5 start="{{list1.children.length+list2.children.length+list3.children.length+list4.children.length+1}}">
                        <li>The Organiser reserves the right to disqualify any Participant who engages in any improper activity or uses the Application or the Campaign in a manner inconsistent with these Terms and Conditions or the terms and conditions of the Application, or otherwise if the Participant breaches any of these Terms and Conditions, the terms and conditions of the Application or applicable law. Disqualification on these grounds may result in the loss of the Prizes. In addition, the Organiser shall have the right to take appropriate administrative and/or legal action, including criminal prosecution, as it deems necessary in its sole discretion.</li>

                        <li>The Participants are solely responsible for the correct input of their details when participating in the Campaign and the Organiser shall not be responsible for any incorrect or inaccurate information supplied by the Participants while participating in the Campaign.</li>

                        <li>The Organiser is not responsible for incorrect or inaccurate transcription of information related to any of the equipment or programming associated with the Campaign or utilized by the Participant, for any human error, for any interruption, deletion, omission, defect, or line failure of any telephone network or electronic transmission, for problems relating to computer equipment, software, inability to access the Application or online service or for any other technical or nontechnical error or malfunction.</li>

                        <li>The Organiser and its respective related companies, parents, subsidiaries, affiliates, and respective agents and their agencies, suppliers and other companies involved in the development or execution of the Campaign or the production or distribution of Campaign materials ("<span class="font-bold">Releases</span>") shall not be held responsible or liable in the event of a printing error or irregular packaging.</li>

                        <li>Subject to clause 33, and to the fullest extent permitted by law, the Organiser, its officers, directors, shareholders, representatives employees, promotion agencies, agents, successors, assignee, and , or service providers, shall not be liable for any direct, indirect, incidental, special or consequential damages arising out of the Campaign or in connection with the Prizes offered through the Campaign or for any products or services offered by the merchants in connection with the Prizes.</li>

                        <li>Prizes may be provided by the Organizers third party partners or merchants. The Organiser makes no representation or warranties of any kind regarding the nature or quality of any Prizes which are provided during the Campaign. The Organiser shall not be held responsible and to the fullest extent permitted by applicable law accepts no liability for any Prizes that are defective in any way or do not meet the Participant’s expectations or requirements.</li>

                        <li>As a condition of participating in this Campaign, Participants agree that any and all claims shall be limited to actual, direct out-of-the-pocket costs incurred, including costs associated with participating in this Campaign, but in no event attorneys’ fees and/or any other indirect costs.</li>

                        <li>All questions or disputes including, but not limited to, questions or disputes regarding eligibility to participate in the Campaign, the Prizes, or a Participant’s compliance with these Terms and Conditions will be resolved by the Organiser in its sole discretion.</li>

                        <li>All issues and questions concerning the construction, validity, interpretation and enforceability of the Terms and Conditions, or the rights and obligations of the Participant and the Organiser in connection with the Campaign, shall be governed by, and construed in accordance with, the laws of Malta and the Courts of Malta shall have exclusive jurisdiction, without giving effect to any choice of law or conflict of law rules or provisions that would cause the application of the laws of any jurisdiction other than Malta. </li>

                        <li>These Terms and Conditions constitute the entire agreement between the Participants and the Organiser pertaining to the subject matter herein and supersede all prior or other arrangements, understandings, negotiations and discussions, whether oral or written. No waiver of any of the provisions of these Terms and Conditions shall be deemed or shall constitute a waiver of any other provisions hereof (whether similar), nor shall waiver constitute a continuing waiver unless otherwise expressly provided. </li>

                        <li>If any provision of these Terms and Conditions is found to be invalid or unenforceable by a court of competent jurisdiction, such provision shall be severed from the remainder of these Terms and Conditions, which will otherwise remain in full force and effect.</li>

                        <li>The processing of personal data by the Organiser in relation to, or for the purpose of, the Campaign is governed by the GSD Privacy Policy (the "<span class="font-bold">Privacy Notice</span>") which can be accessed through the following link <a href="https://gsd.com.mt/privacy-policy" target="_blank">https://gsd.com.mt/privacy-policy</a>. By participating in the Campaign, you acknowledge that you have been provided with a copy of the Privacy Notice and that you understand and accept the contents thereof.</li>
                    </ol>
                </ng-template>
            </mat-expansion-panel>
        </div>
    </mat-accordion>
</div>